import $ from 'jquery';

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax } from '../global/helpers';

$Elements.document.on(Events.page.enter, () => {

	$('.season-dropdown').each(function() {

		const $dropdown = $(this);
		const $hidden = $dropdown.find('input.ajax-posts-filter');
		const $button = $dropdown.find('.season-dropdown-toggle');
		const $items = $dropdown.find('.dropdown-item');

		$items.on('click', function(e) {
			e.preventDefault();

			const $item = $(this);
			const value = $item.data('value');
			const label = $item.text();

			$items.removeClass('active');
			$item.addClass('active');

			$hidden.val(value);
			$button.text(label);

			if(typeof bootstrap !== 'undefined' && bootstrap.Dropdown) {
				const instance = bootstrap.Dropdown.getOrCreateInstance($button[0]);
				instance.hide();
			}

			$hidden.trigger('change');
		});
	});

	// ---------- Ajax Posts ----------

	if(typeof ajax_posts_params !== 'undefined') {

		$('form.ajax-posts-form').each(function() {

			const form = $(this);
			const more = form.find('button.more-btn');
			const reset = form.find('button.reset-btn');
			const page = form.find('input[name=page]');
			const filters = form.find('.ajax-posts-filter');
			const content = form.find('.ajax-posts');
			const noResults = form.find('.no-results');

			more.on(Events.click, () => form.data('append', true));

			reset.on(Events.click, e => {
				e.preventDefault();
				form.data('append', false);
				page.val(1);
				form.submit();
			});

			filters.on('change', () => {
				form.data('append', false);
				page.val(1);
				form.submit();
			});

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				more.attr('disabled', true);
				Elements.LoadingBar.classList.add(Classes.loading);

				const form_data = new FormData(form[0]);
				form_data.append('action', ajax_posts_params.action);
				form_data.append('nonce', ajax_posts_params.nonce);

				try {

					const response = await ajax({
						url: ajax_posts_params.url,
						type: 'POST',
						dataType: 'json',
						data: form_data,
						processData: false,
						contentType: false,
					});

					if(response.data.content) {
						noResults.addClass(Classes.hidden);

						if(!form.data('append')) {
							content.empty();
						}

						content.append($(response.data.content));
						content.removeClass(Classes.hidden);
					}
					else {
						content.addClass(Classes.hidden);
						noResults.removeClass(Classes.hidden);
					}

					if(response.data.next_page === 0) {
						more.addClass(Classes.hidden);
						more.attr('disabled', true);
					}
					else {
						page.val(response.data.next_page);
						more.removeClass(Classes.hidden);
					}

					$Elements.window.trigger(Events.animation.refresh);
					$Elements.window.trigger(Events.resize);
				}
				catch(e) {
					content.addClass(Classes.hidden);
					noResults.removeClass(Classes.hidden);
				}

				more.attr('disabled', false);
				Elements.LoadingBar.classList.remove(Classes.loading);

				return false;
			});
		});
	}
});
